module.exports = __webpack_public_path__ + "img/金属材料学3_1.ca7be9e0.png";